module.exports = __webpack_public_path__ + "static/media/Document6.8d4be362.svg";